<template>
  <div>
    <transfer v-if="serviceType === 'airporttransfer'" />
    <rental v-else-if="serviceType === 'rental'" />
  </div>
</template>

<script>
import transfer from "@/components/availability/result/instant/ResultTransfer";
import rental from "@/components/availability/result/instant/ResultRental";

export default {
  components: {
    transfer,
    rental,
  },
  computed: {
    serviceType: function () {
      return this.$route.query.svc.toLowerCase();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/availability/result/instant/Result.vue